import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, Link } from "@mui/material";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";

/**
 * Crisis vangnet. Shown — instead of the sales flow — when the well-being check
 * is very low. Always offers immediate human help.
 */
export default function SupportNotice() {
  const { t } = useTranslation();
  return (
    <Box sx={{ p: 3, borderRadius: "var(--radius-lg)", bgcolor: "var(--surface)", border: "1px solid var(--border)", boxShadow: "var(--shadow-md)" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5 }}>
        <FavoriteRoundedIcon sx={{ color: "error.main" }} />
        <Typography variant="h3" sx={{ fontSize: "1.25rem", m: 0 }}>{t("support.title")}</Typography>
      </Box>
      <Typography sx={{ mb: 2 }}>{t("support.body")}</Typography>
      <Box component="ul" sx={{ pl: 0, listStyle: "none", m: 0, display: "grid", gap: 1.25 }}>
        <li>
          <strong>1813</strong> — {t("support.line1813")} · <Link href="tel:1813">{t("support.call")} 1813</Link> ·{" "}
          <Link href="https://www.zelfmoord1813.be" target="_blank" rel="noreferrer">zelfmoord1813.be</Link>
        </li>
        <li>
          <strong>112</strong> — {t("support.line112")} · <Link href="tel:112">{t("support.call")} 112</Link>
        </li>
        <li>
          <strong>Tele-Onthaal</strong> — <Link href="tel:106">{t("support.call")} 106</Link> ({t("support.lineTele")})
        </li>
      </Box>
    </Box>
  );
}
